import React from 'react';
import { Collection } from '../types.ts';

interface HeaderProps {
  collections: Collection[];
  selectedCollectionId: string;
  onSelectCollection: (id: string) => void;
}

const Header: React.FC<HeaderProps> = ({ collections, selectedCollectionId, onSelectCollection }) => {
  return (
    <header className="bg-white p-4 rounded-lg shadow-md flex flex-col sm:flex-row justify-between items-center gap-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center">
          <i className="fas fa-swatchbook text-2xl text-white"></i>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Calcolo Costi Tessuti</h1>
          <p className="text-sm text-gray-500">Gestione Collezione & Consulente AI</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <label htmlFor="collection-select" className="text-sm font-medium text-gray-700">Collezione:</label>
        <select
          id="collection-select"
          value={selectedCollectionId}
          onChange={(e) => onSelectCollection(e.target.value)}
          className="w-56 p-2 border border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 transition bg-white"
        >
          <option value="new" className="font-semibold text-sky-600">-- Nuova Collezione --</option>
          {collections.map(collection => (
            <option key={collection.id} value={collection.id}>
              {collection.name} {collection.isOfficial && ' (Ufficiale)'}
            </option>
          ))}
        </select>
      </div>
    </header>
  );
};

export default Header;